export default __webpack_public_path__ + "static/media/icon_evn_setting_active.25b90fee.svg";